export const CURRENCYLIST = [
  {
    value: 'EUR',
    shorthand: '€',
  },
  {
    value: 'USD',
    shorthand: '$',
  },
  {
    value: 'CHF',
    shorthand: 'CHF',
  },
  {
    value: 'GBP',
    shorthand: '£',
  },
  {
    value: 'AUD',
    shorthand: '$',
  },
  {
    value: 'NZD',
    shorthand: '$',
  },
  {
    value: 'IDR',
    shorthand: 'Rp',
  },
  {
    value: 'INR',
    shorthand: '₹',
  },
  {
    value: 'MYR',
    shorthand: 'RM',
  },
  {
    value: 'THB',
    shorthand: '฿',
  },
  {
    value: 'CNY',
    shorthand: '¥',
  },
  {
    value: 'SEK',
    shorthand: 'Kr',
  },
  {
    value: 'JPY',
    shorthand: '¥',
  },
  {
    value: 'CAD',
    shorthand: 'CAD',
  },
];

export const QUANTITYUNITLIST = [
  {
    value: 'Ctn',
    code: 'Ctn',
    shorthand: 'Ctn',
  },
  {
    value: 'ST',
    code: 'ST',
    shorthand: 'ST',
  },
  {
    value: 'Lbs',
    code: 'Lbs',
    shorthand: 'Lbs',
  },
  {
    value: 'Truck(s)',
    code: 'Ftruck',
    shorthand: 'Truck',
  },
  {
    value: 'Kg',
    code: 'Kg',
    shorthand: 'Kg',
  },
  {
    value: 'Shpmt',
    code: 'shipment',
    shorthand: 'Shpmt',
  },
  {
    value: 'Lot',
    code: 'Lot',
    shorthand: 'Lot',
  },
  {
    value: 'GT',
    code: 'GT',
    shorthand: 'GT',
  },
  {
    value: 'Unit',
    code: 'Unit',
    shorthand: 'Unit',
  },
  {
    value: 'T',
    code: 'T',
    shorthand: 'T',
  },
  {
    value: 'Hold',
    code: 'Hold',
    shorthand: 'Hold',
  },
];

export const COUNTRIESLIST = [
  {
    currency: 'USD',
    value: 'Afghanistan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Aland Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Albania',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Algeria',
    code: null,
  },
  {
    currency: 'USD',
    value: 'American Samoa',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Andorra',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Angola',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Anguilla',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Antarctica',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Antigua and Barbuda',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Argentina',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Armenia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Aruba',
    code: null,
  },
  {
    currency: 'AUD',
    value: 'Australia',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Austria',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Azerbaijan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Bahamas',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Bahrain',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Bangladesh',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Barbados',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Belarus',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Belgium',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Belize',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Benin',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Bermuda',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Bhutan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Bolivia',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Bosnia and Herzegovina',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Botswana',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Bouvet Island',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Brazil',
    code: null,
  },
  {
    currency: 'USD',
    value: 'British Indian Ocean Territory',
    code: null,
  },
  {
    currency: 'USD',
    value: 'British Virgin Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Brunei Darussalam',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Bulgaria',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Burkina Faso',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Burundi',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Cambodia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Cameroon',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Canada',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Cape Verde',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Cayman Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Central African Republic',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Chad',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Chile',
    code: null,
  },
  {
    currency: 'USD',
    value: 'China',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Christmas Island',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Cocos (Keeling) Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Colombia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Comoros',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Congo Kinshasa',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Congo Brazzaville',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Cook Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Costa Rica',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Croatia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Cuba',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Cyprus',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Czech Republic',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Denmark',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Djibouti',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Dominica',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Dominican Republic',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Ecuador',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Egypt',
    code: null,
  },
  {
    currency: 'USD',
    value: 'El Salvador',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Equatorial Guinea',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Eritrea',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Estonia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Ethiopia',
    code: null,
  },
  {
    currency: 'GBP',
    value: 'Falkland Islands (Malvinas)',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Faroe Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Fiji',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Finland',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'France',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'French Guiana',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'French Polynesia',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'French Southern Territories',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Gabon',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Gambia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Georgia',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Germany',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Ghana',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Gibraltar',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Greece',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Greenland',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Grenada',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Guadeloupe',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Guam',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Guatemala',
    code: null,
  },
  {
    currency: 'GBP',
    value: 'Guernsey',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Guinea',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Guinea-Bissau',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Guyana',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Haiti',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Heard and Mcdonald Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Holy See (Vatican City State)',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Honduras',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Hong Kong, SAR China',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Hungary',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Iceland',
    code: null,
  },
  {
    currency: 'USD',
    value: 'India',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Indonesia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Iran',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Iraq',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Ireland',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Isle of Man',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Israel',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Italy',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Ivory Coast',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Jamaica',
    code: null,
  },
  {
    currency: 'JPY',
    value: 'Japan',
    code: null,
  },
  {
    currency: 'GBP',
    value: 'Jersey',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Jordan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Kazakhstan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Kenya',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Kiribati',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Kuwait',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Kyrgyzstan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Lao',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Latvia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Lebanon',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Lesotho',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Liberia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Libya',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Liechtenstein',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Lithuania',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Luxembourg',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Macao',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Macedonia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Madagascar',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Malawi',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Malaysia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Maldives',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Mali',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Malta',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Marshall Islands',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Martinique',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Mauritania',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Mauritius',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Mayotte',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Mexico',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Micronesia',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Moldova',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Monaco',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Mongolia',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Montenegro',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Montserrat',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Morocco',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Mozambique',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Myanmar',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Namibia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Nauru',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Nepal',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Netherlands',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Netherlands Antilles',
    code: null,
  },
  {
    currency: 'USD',
    value: 'New Caledonia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'New Zealand',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Nicaragua',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Niger',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Nigeria',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Niue',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Norfolk Island',
    code: null,
  },
  {
    currency: 'USD',
    value: 'North Korea',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Northern Mariana Islands',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Norway',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Oman',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Pakistan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Palau',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Panama',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Papua New Guinea',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Paraguay',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Peru',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Philippines',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Pitcairn',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Poland',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Portugal',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Puerto Rico',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Qatar',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Réunion',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Romania',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Russia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Rwanda',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Saint Kitts and Nevis',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Saint Lucia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Saint Pierre and Miquelon',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Saint Vincent and Grenadines',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Saint-Barthélemy',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Saint-Martin (French part)',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Samoa',
    code: null,
  },
  {
    currency: 'USD',
    value: 'San Marino',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Sao Tome and Principe',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Saudi Arabia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Senegal',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Serbia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Seychelles',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Sierra Leone',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Singapore',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Slovakia',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Slovenia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Solomon Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Somalia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'South Africa',
    code: null,
  },
  {
    currency: 'USD',
    value: 'South Georgia and the South Sandwich Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'South Korea',
    code: null,
  },
  {
    currency: 'USD',
    value: 'South Sudan',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Spain',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Sri Lanka',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Sudan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Suriname',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Svalbard and Jan Mayen Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Swaziland',
    code: null,
  },
  {
    currency: 'SEK',
    value: 'Sweden',
    code: null,
  },
  {
    currency: 'CHF',
    value: 'Switzerland',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Syria',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Taiwan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Tajikistan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Tanzania',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Thailand',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Timor-Leste',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Togo',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Tokelau',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Tonga',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Trinidad and Tobago',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Tunisia',
    code: null,
  },
  {
    currency: 'EUR',
    value: 'Turkey',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Turkmenistan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Turks and Caicos Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Tuvalu',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Uganda',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Ukraine',
    code: null,
  },
  {
    currency: 'USD',
    value: 'United Arab Emirates',
    code: null,
  },
  {
    currency: 'GBP',
    value: 'United Kingdom',
    code: null,
  },
  {
    currency: 'USD',
    value: 'United States of America',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Uruguay',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Uzbekistan',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Vanuatu',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Venezuela',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Viet Nam',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Virgin Islands, US',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Wallis and Futuna Islands',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Yemen',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Zambia',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Zimbabwe',
    code: null,
  },
  {
    currency: 'USD',
    value: 'Pennsylvania',
    code: null,
  },
];

export const LOGISTICMATERIALLIST = [
  {
    value: 'AMPLIROLL',
  },
  {
    value: 'TRAX',
  },
  {
    value: 'MULTI',
  },
  {
    value: 'TRAILER',
  },
  {
    value: 'Truck cranes',
  },
  {
    value: 'Skip',
  },
  {
    value: 'DEDICATED BUCKET',
  },
  {
    value: 'TRAY',
  },
  {
    value: 'COMPACTOR',
  },
  {
    value: 'BATTERY HOLDER',
  },
  {
    value: 'TAUT-LINER',
  },
  {
    value: 'Tautliner',
  },
  {
    value: '40 HC',
  },
  {
    value: '20 HC',
  },
  {
    value: 'Bulk Cargo',
  },
  {
    value: 'RAIL CAR',
  },
];

export const REGIONLIST = [
  {
    value: 'EUR',
    shorthand: '€',
  },
  {
    value: 'USD',
    shorthand: '$',
  },
  {
    value: 'CHF',
    shorthand: 'CHF',
  },
  {
    value: 'GBP',
    shorthand: '£',
  },
  {
    value: 'AUD',
    shorthand: '$',
  },
  {
    value: 'NZD',
    shorthand: '$',
  },
  {
    value: 'IDR',
    shorthand: 'Rp',
  },
  {
    value: 'INR',
    shorthand: '₹',
  },
  {
    value: 'MYR',
    shorthand: 'RM',
  },
  {
    value: 'THB',
    shorthand: '฿',
  },
  {
    value: 'CNY',
    shorthand: '¥',
  },
  {
    value: 'SEK',
    shorthand: 'Kr',
  },
  {
    value: 'JPY',
    shorthand: '¥',
  },
  {
    value: 'CAD',
    shorthand: 'CAD',
  },
];

export const PORTOFLOADINGLIST = [
  {
    value: 'Port of Salaya',
    country: 'India',
  },
  {
    value: 'Port of Porbandar',
    country: 'India',
  },
  {
    value: 'Port of Paradip',
    country: 'India',
  },
  {
    value: 'Port of Navlakhi',
    country: 'India',
  },
  {
    value: 'Port of Mormugao',
    country: 'India',
  },
  {
    value: 'Port of Mangalore',
    country: 'India',
  },
  {
    value: 'Port of Hazira',
    country: 'India',
  },
  {
    value: 'Port of Mandvi',
    country: 'India',
  },
  {
    value: 'Port of Magdalla',
    country: 'India',
  },
  {
    value: 'Port of Kandla',
    country: 'India',
  },
  {
    value: 'Port of Kakinada',
    country: 'India',
  },
  {
    value: 'Port of Dholera',
    country: 'India',
  },
  {
    value: 'Port of Bedi Bunder',
    country: 'India',
  },
  {
    value: 'Port of Visakhapatnam',
    country: 'India',
  },
  {
    value: 'Port of Pipavav',
    country: 'India',
  },
  {
    value: 'Port of Mundra',
    country: 'India',
  },
  {
    value: 'Port of Mumbai',
    country: 'India',
  },
  {
    value: 'Port of Kolkata',
    country: 'India',
  },
  {
    value: 'Nhava Sheva',
    country: 'India',
  },
  {
    value: 'Port of Haldia',
    country: 'India',
  },
  {
    value: 'Port of Cochin',
    country: 'India',
  },
  {
    value: 'Port of Chennai',
    country: 'India',
  },
  {
    value: 'Port Puneri',
    country: 'India',
  },
];

export const INCOTERMSLIST = [
  {
    marketType: 'EXPORT',
    code: 'FAS',
    value: 'FAS',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'CIF',
    value: 'CIF',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'FRC',
    value: 'FRC',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'CIP',
    value: 'CIP',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'DDP',
    value: 'DDP',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'DAT',
    value: 'DAT',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'DAP',
    value: 'DAP',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'CPT',
    value: 'CPT',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'FAS',
    value: 'FAS',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'FOB',
    value: 'FOB',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'CFR',
    value: 'CFR',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'FCA',
    value: 'FCA',
    type: 'BUY',
  },
  {
    marketType: 'EXPORT',
    code: 'EXW',
    value: 'EXW',
    type: 'BUY',
  },
  {
    marketType: 'LOCAL',
    code: 'EXW',
    value: 'EXW',
    type: 'BUY',
  },
  {
    marketType: 'LOCAL',
    code: 'EXW',
    value: 'EXW',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'FRC',
    value: 'FRC',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'CIP',
    value: 'CIP',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'DDP',
    value: 'DDP',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'DAT',
    value: 'DAT',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'DAP',
    value: 'DAP',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'CPT',
    value: 'CPT',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'FAS',
    value: 'FAS',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'FOB',
    value: 'FOB',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'CIF',
    value: 'CIF',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'CFR',
    value: 'CFR',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'FCA',
    value: 'FCA',
    type: 'SELL',
  },
  {
    marketType: 'EXPORT',
    code: 'EXW',
    value: 'EXW',
    type: 'SELL',
  },
  {
    marketType: 'LOCAL',
    code: 'DAP',
    value: 'DAP',
    type: 'BUY',
  },
  {
    marketType: 'LOCAL',
    code: 'DAP',
    value: 'DEL',
    type: 'BUY',
  },
  {
    marketType: 'LOCAL',
    code: 'DAP',
    value: 'DEL to Mill',
    type: 'SELL',
  },
];

export const PRICEINDEXESLIST = [
  {
    value: 'LME Aluminium 3-month official',
    period: '3-month official',
  },
  {
    value: 'LME Aluminium Alloy 3-month official',
    period: '3-month official',
  },
  {
    value: 'LME Copper 3-month official',
    period: '3-month official',
  },
  {
    value: 'LME Lead 3-month official',
    period: '3-month official',
  },
  {
    value: 'LME Nasaac 3-month official',
    period: '3-month official',
  },
  {
    value: 'LME Nickel 3-month official',
    period: '3-month official',
  },
  {
    value: 'LME Tin 3-month official',
    period: '3-month official',
  },
  {
    value: 'LME Zinc 3-month official',
    period: '3-month official',
  },
  {
    value: 'LME Aluminium Alloy cash official',
    period: 'cash official',
  },
  {
    value: 'LME Aluminium cash official',
    period: 'cash official',
  },
  {
    value: 'LME Cobalt cash official',
    period: 'cash official',
  },
  {
    value: 'LME Copper cash official',
    period: 'cash official',
  },
  {
    value: 'LME Lead cash official',
    period: 'cash official',
  },
  {
    value: 'LME Nasaac cash official',
    period: 'cash official',
  },
  {
    value: 'LME Nickel cash official',
    period: 'cash official',
  },
  {
    value: 'LME Tin cash official',
    period: 'cash official',
  },
  {
    value: 'LME Zinc cash official',
    period: 'cash official',
  },
  {
    value: 'CME Aluminium Japan Premium spot month',
    period: 'spot month',
  },
  {
    value: 'CME Aluminum A380 Alloy spot month',
    period: 'spot month',
  },
  {
    value: 'CME Aluminum Midwest US transaction premium spot month',
    period: 'spot month',
  },
  {
    value: 'CME Ferrous scrap US midwest #1 busheling spot month',
    period: 'spot month',
  },
  {
    value: 'CME hot dip galvanized steel US premium spot month',
    period: 'spot month',
  },
  {
    value: 'CME Steel North Europe hot rolled coil spot month',
    period: 'spot month',
  },
  {
    value: 'CME Steel US Midwest hot rolled coil spot month',
    period: 'spot month',
  },
  {
    value: 'COMEX Copper spot month',
    period: 'spot month',
  },
  {
    value: 'ICE Brent Crude Oil spot month',
    period: 'spot month',
  },
  {
    value: 'LME Aluminium Eastern Asia premium spot month',
    period: 'spot month',
  },
  {
    value: 'LME Aluminium premium duty paid US Midwest spot month',
    period: 'spot month',
  },
  {
    value: 'LME Aluminium Southeast Asia premium spot month',
    period: 'spot month',
  },
  {
    value: 'LME Aluminium US premium spot month',
    period: 'spot month',
  },
  {
    value: 'LME Aluminium Western Europe premium spot month',
    period: 'spot month',
  },
  {
    value: 'LME HMS 1/2 (80:20) cfr Turkey spot month',
    period: 'spot month',
  },
  {
    value: 'LME Molybdenum spot month',
    period: 'spot month',
  },
  {
    value: 'LME Rebar fob Turkey spot month',
    period: 'spot month',
  },
  {
    value: 'LME Steel HRC fob China spot month',
    period: 'spot month',
  },
  {
    value: 'LME Steel HRC fob N America spot month',
    period: 'spot month',
  },
  {
    value: 'Nymex Iron Ore 62% Fe cfr China spot month',
    period: 'spot month',
  },
  {
    value: 'Nymex Natural Gas spot month',
    period: 'spot month',
  },
  {
    value: 'Nymex WTI crude light spot month',
    period: 'spot month',
  },
  {
    value: 'CME Aluminium Japan Premium',
    period: 'month average',
  },
  {
    value: 'CME Aluminum A380 Alloy',
    period: 'month average',
  },
  {
    value: 'CME Aluminum Midwest US transaction premium',
    period: 'month average',
  },
  {
    value: 'CME Ferrous scrap US midwest #1 busheling',
    period: 'month average',
  },
  {
    value: 'CME Steel North Europe hot rolled coil',
    period: 'month average',
  },
  {
    value: 'CME Steel US Midwest hot rolled coil',
    period: 'month average',
  },
  {
    value: 'LME Alumina',
    period: 'month average',
  },
  {
    value: 'LME Aluminium Eastern Asia premium',
    period: 'month average',
  },
  {
    value: 'LME Aluminium premium duty paid US Midwest',
    period: 'month average',
  },
  {
    value: 'LME Aluminium Southeast Asia premium',
    period: 'month average',
  },
  {
    value: 'LME Aluminium US premium',
    period: 'month average',
  },
  {
    value: 'LME Aluminium Western Europe premium',
    period: 'month average',
  },
  {
    value: 'LME HMS 1/2 (80:20) cfr Turkey',
    period: 'month average',
  },
  {
    value: 'LME Rebar fob Turkey',
    period: 'month average',
  },
  {
    value: 'LME Steel HRC fob China',
    period: 'month average',
  },
  {
    value: 'LME Steel HRC fob N America',
    period: 'month average',
  },
  {
    value: 'LME Zinc Cash',
    period: 'month average',
  },
];

export const OTHERPRODUCTSLIST = [
  {
    name: 'Freight rate',
    group: 'Transport',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Transport cost',
    group: 'Transport',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Pre-carriage rate',
    group: 'Transport',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Downgrade',
    group: 'Deviation',
    code: 'DW',
    defaultVolume: null,
  },
  {
    name: 'Non Metals',
    group: 'Deviation',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Unexpected',
    group: 'Deviation',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Empty transportation',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Penalty',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Transportation on material refused',
    group: 'Other',
    code: 'TMR',
    defaultVolume: 'Ftruck',
  },
  {
    name: 'Transportation on material without value',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Agent',
    group: 'Transport',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Inspector',
    group: 'Transport',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'BL changes',
    group: 'Admin fees',
    code: 'FM 516537_',
    defaultVolume: null,
  },
  {
    name: 'Collection services',
    group: 'Transport',
    code: 'CS',
    defaultVolume: 'Ctn',
  },
  {
    name: 'BL Change',
    group: 'Admin fees',
    code: 'BLC',
    defaultVolume: 'shipment',
  },
  {
    name: 'CCIC Cost',
    group: 'Admin fees',
    code: 'CCIC',
    defaultVolume: 'shipment',
  },
  {
    name: 'intercompany buy',
    group: 'Services',
    code: 'custom product',
    defaultVolume: null,
  },
  {
    name: 'intercompany sell',
    group: 'Services',
    code: 'custom product 2',
    defaultVolume: null,
  },
  {
    name: 'Extension penalties',
    group: 'Deviation',
    code: 'Extension',
    defaultVolume: null,
  },
  {
    name: 'D&D charges',
    group: 'Transport',
    code: 'D&D charges',
    defaultVolume: 'Ctn',
  },
  {
    name: 'Overcharge',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Discount - Global',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Discount',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Commision to buyer',
    group: 'Other',
    code: 'CB',
    defaultVolume: null,
  },
  {
    name: 'Advance payment',
    group: 'Deviation',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Penalty x2',
    group: 'Transport',
    code: 'PEN',
    defaultVolume: null,
  },
  {
    name: 'BL amendment',
    group: 'Transport',
    code: '01',
    defaultVolume: null,
  },
  {
    name: 'Debit note',
    group: 'Transport',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Credit note',
    group: 'Banking fees',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Split',
    group: 'Transport',
    code: 'DW',
    defaultVolume: null,
  },
  {
    name: 'Cargo bulk cost',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Sale agent',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Purchase agent',
    group: 'Other',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'bank charges',
    group: 'Services',
    code: 'BC',
    defaultVolume: 'shipment',
  },
  {
    name: 'Transport',
    group: 'Admin fees',
    code: null,
    defaultVolume: null,
  },
  {
    name: 'Warehousing',
    group: 'Other',
    code: 'WH12',
    defaultVolume: null,
  },
  {
    name: 'Insurance Port to Port @0.1%',
    group: 'Other',
    code: null,
    defaultVolume: 'Unit',
  },
  {
    name: 'Processing fee',
    group: 'Other',
    code: 'PFEE',
    defaultVolume: null,
  },
  {
    name: 'Inspection',
    group: 'Services',
    code: 'INSP',
    defaultVolume: null,
  },
  {
    name: 'BL switch',
    group: 'Admin fees',
    code: '10011',
    defaultVolume: null,
  },
];